import { ApiClient } from './client.js'
import { WAVEFORMS } from './resources.js'

const client = new ApiClient()

export default {
  retrieve (waveformId) {
    return client.get(`${WAVEFORMS}${waveformId}/`)
  }
}
